import { StatelessComponent } from 'react'
import * as moment from 'moment'
import { DATE_FORMAT_US } from 'constants/datetime'
import PasswordChangeForm from 'components/molecules/forms/PasswordChangeForm'
import DescriptionList from 'components/atoms/DescriptionList'
import { onFormSubmit } from 'helpers/formHelpers'
import { showPasswordChangeFormActionCreator } from 'actions/settingsActions'
import TextButton from 'components/atoms/buttons/TextButton'
import * as styles from 'components/features/pfm/AccountSettingsModule/AccountSettingsModule.css'

export type AccountSettingsModuleStateProps = {
  firstName: string
  lastName: string
  email: string
  birthDate: string
  passwordChangeFormVisible: boolean
}

export type AccountSettingsModuleDispatchProps = {
  showPasswordChangeForm: typeof showPasswordChangeFormActionCreator
}

type AccountSettingsModuleProps = AccountSettingsModuleStateProps & AccountSettingsModuleDispatchProps

const AccountSettingsModule: StatelessComponent<AccountSettingsModuleProps> = (props) => {
  const {
    firstName,
    lastName,
    email,
    birthDate,
    passwordChangeFormVisible,
    showPasswordChangeForm,
  } = props

  const listItems = [
    { label: 'First Name', value: firstName, qaMarker: 'first-name' },
    { label: 'Last Name', value: lastName, qaMarker: 'last-name' },
    { label: 'Birth Date', value: moment(birthDate).format(DATE_FORMAT_US), qaMarker: 'birthdate' },
    { label: 'User ID', value: email, qaMarker: 'email' },
  ]

  const showPasswordChangeFormLink = !passwordChangeFormVisible && (
    <section>
      <TextButton size='large' onClick={ () => showPasswordChangeForm(true) } qaMarker='change-password'>
        Change Password
      </TextButton>
    </section>
  )

  const footer = !passwordChangeFormVisible && (
    <footer className={ styles.footer }>
      { showPasswordChangeFormLink }
    </footer>
  )

  const passwordChangeForm = passwordChangeFormVisible && (
    <PasswordChangeForm
      onSubmit={ onFormSubmit }
      onCancel={ () => showPasswordChangeForm(false) }
    />
  )

  return (
    <div className={ styles.form }>
      <DescriptionList items={ listItems } />
      { footer }
      { passwordChangeForm }
    </div>
  )
}

export default AccountSettingsModule
